import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import WarningIcon from "@mui/icons-material/Warning";
import { MessageModal } from "../components";
import { accessStore, getAccessStatus } from "../services/public.service";
import { useSelector } from "react-redux";
import { enterStore } from "../utils";
import { Loader } from "../components/common/Loader";

export const MessagesControl = () => {
  let engineInterval: any;
  const navigation = useNavigate();
  const { state } = useLocation();

  const { userLogged } = useSelector((state: any) => state.session);
  const { enterGroup } = useSelector((state: any) => state.cart);

  const [apiMsg, setApiMsg] = useState(false);
  const [iconSelected, setIconSelected] = useState(() => WarningIcon);
  const [titleSelected, setTitleSelected] = useState("");
  const [descSelected, setDescSelected] = useState([]);
  const [actionsSelected, setActionsSelected] = useState([]);

  const startInterval = () => {
    engineInterval = setInterval(() => accessStatus(), 3000);
  };

  const stopInterval = () => {
    clearInterval(engineInterval);
  };

  // FUNCION QUE PIDE MENSAJES CONSTANTEMENTE SOBRE ESTATUS DE LA PUERTA Y PAGO
  const accessStatus = async () => {
    try {
      const response: any = await getAccessStatus(userLogged.login, 9);
      if (response.result.length > 0) {
        stopInterval();
        const accessStoreResponse = response.result[response.result.length - 1];
        const codeResponse = parseInt(accessStoreResponse.code);

        await configMsgByCode(codeResponse);
      }
    } catch (error) { }
  };

  // Funcion para estructurar modal de notificacion y que accione el usuario
  // abrir flujo acompañantes
  const configMsgByCode = (codeResponse: any) => {
    const elementCode: any = messagesByCodeDoor.find(
      (el) => el.code === codeResponse
    );
    setIconSelected(elementCode.icon);
    setTitleSelected(elementCode.title);
    setDescSelected(elementCode.description);
    setActionsSelected(elementCode.actions);
    setApiMsg(true);
  };

  const goInStore = async () => {
    await accessStore(userLogged.login, 9, 1, true);
  };

  const goOutStore = async () => {
    await accessStore(userLogged.login, 9, 1, false);
  };

  const messagesByCodeDoor = [
    {
      code: 14, // Tienda Cerrada
      icon: () => WarningIcon,
      title: "Tienda Cerrada",
      description: ["Tienda cerrada"],
      actions: [
        {
          title: "Entendido",
          colorPrimary: true,
          onClick: () => {
            stopInterval();
            setApiMsg(false);
            navigation("/");
          },
        },
      ],
    },
    {
      code: 1, // Puerta de entrada ocupada
      icon: () => WarningIcon,
      title: "Hall de ingreso ocupado",
      description: [
        "El hall de ingreso se encuentra ocupado. Por favor aguarda un instante para continuar.",
      ],
      actions: [
        {
          title: "Entendido",
          colorPrimary: true,
          onClick: () => {
            stopInterval();
            setApiMsg(false);
            navigation("/");
          },
        },
      ],
    },
    {
      code: 2, // Hay mas de un cliente en el hall. Deben ingresar de a uno
      icon: () => WarningIcon,
      title: "Salir a la vereda",
      description: [
        "Ha ocurrido un problema, por favor salir del hall de ingreso a la vereda y volver a escanear el QR.",
        "Recordá que al hall se debe ingresar de a una persona a la vez.",
      ],
      actions: [
        {
          title: "Salir a la vereda",
          colorPrimary: true,
          onClick: () => {
            setApiMsg(false);
            startInterval();
          },
        },
      ],
    },
    {
      code: 3, // Cliente ingresa al hall de ingreso y es detectado correctamente
      icon: () => WarningIcon,
      title: "Bienvenido a la tienda!",
      description: ["Por favor, confirma el ingreso para continuar"],
      actions: [
        {
          title: "Confirmar ingreso",
          colorPrimary: true,
          onClick: () => {
            setApiMsg(false);
            goInStore();
            startInterval();
          },
        },
        {
          title: "Cancelar",
          colorPrimary: false,
          onClick: () => {
            stopInterval();
            goOutStore();
            setApiMsg(false);
            navigation("/");
          },
        },
      ],
    },
    {
      code: 4, // Usuario no ingresa o no es detectado en el hall de ingreso
      icon: () => WarningIcon,
      title: "Usted no ingresó",
      description: ["No se ha detectado el ingreso a la tienda."],
      actions: [
        {
          title: "Volver a intentarlo",
          colorPrimary: true,
          onClick: () => {
            stopInterval();
            setApiMsg(false);
            navigation("/");
          },
        },
      ],
    },
    {
      code: 5, // Usuario confirmo y no ingresó a la tienda
      icon: () => WarningIcon,
      title: "Salir del hall de ingreso",
      description: [
        "Por favor, no permanecer en el hall de ingreso.",
        "Una vez confirmado, ingresar a la tienda.",
      ],
      actions: [
        {
          title: "Entendido",
          colorPrimary: true,
          onClick: () => setApiMsg(false),
        },
      ],
    },
    {
      code: 6, // se debe abrir la puerta 1 indefinidamente hasta que salga
      icon: () => WarningIcon,
      title: "Error de registración",
      description: [
        "Por favor, salir del hall de ingreso.",
        "Reintente la lectura del QR de la puerta.",
      ],
      actions: [
        {
          title: "Entendido",
          colorPrimary: true,
          onClick: () => {
            stopInterval();
            setApiMsg(false);
            navigation("/");
          },
        },
      ],
    },
    {
      // abrir la logica a acompañantes con contador
      code: 7, // INGRESO A LA TIENDA / SI ENTRA SOLO VA AL QR / SI VA ACOMPAÑADO MUESTRA ESTO
      icon: () => WarningIcon,
      title: "Bienvenido a MiniGO",
      description: [
        !enterGroup ? "Ahora puedes tomar productos" : "¿Ingresa alguien más?",
      ],
      actions: [
        enterGroup && {
          title: "Si",
          onClick: async () => {
            await setApiMsg(false);
            await enterStore(userLogged.login, "9", "1", "in")
              .then(() => startInterval())
              .catch((err) => console.error(err));
          },
        },
        {
          title: !enterGroup ? "Entendido" : "No",
          onClick: async () => {
            await setApiMsg(false);
            await stopInterval();
            await navigation("/cart");
          },
        },
      ],
    },
    {
      code: 8, //
      icon: () => WarningIcon,
      title: "Salir del hall de ingreso",
      description: [
        "Por favor, no permanecer en el hall de ingreso.",
        "Debe retirarse del hall.",
      ],
      actions: [
        {
          title: "Entendido",
          colorPrimary: true,
          onClick: () => {
            stopInterval();
            setApiMsg(false);
            navigation("/");
          },
        },
      ],
    },
    {
      code: 9, //
      icon: () => WarningIcon,
      title: "--",
      description: ["No found"],
      actions: [
        {
          title: "Entendido",
          colorPrimary: true,
          onClick: () => {
            stopInterval();
            setApiMsg(false);
            navigation("/");
          },
        },
      ],
    },
    {
      code: 10, // Usuario confirmo y no ingresó a la tienda
      icon: () => WarningIcon,
      title: "--",
      description: ["Saliste de la tienda"],
      actions: [
        {
          title: "Entendido",
          colorPrimary: true,
          onClick: () => {
            stopInterval();
            setApiMsg(false);
            navigation("/");
          },
        },
      ],
    },
    {
      code: 100, // Usuario confirmo y no ingresó a la tienda
      icon: () => WarningIcon,
      title: "Pago realizado",
      description: ["El pago fue procesado con éxito"],
      actions: [
        {
          title: "Entendido",
          colorPrimary: true,
          onClick: () => {
            stopInterval();
            setApiMsg(false);
            navigation("/");
          },
        },
      ],
    },
    {
      code: 111, // Usuario confirmo y no ingresó a la tienda
      icon: () => WarningIcon,
      title: "Usted se ha retirado",
      description: ["Se ha retirado sin productos en la tienda."],
      actions: [
        {
          title: "Entendido",
          colorPrimary: true,
          onClick: () => {
            stopInterval();
            setApiMsg(false);
            navigation("/");
          },
        },
      ],
    },
    {
      code: 12, // multiples grupos en salida
      icon: () => WarningIcon,
      title: "Volver a la tienda",
      description: [
        "Su grupo debe volver a la tienda.",
        "Solo puede salir un grupo a la vez.",
      ],
      actions: [
        {
          title: "Entendido",
          colorPrimary: true,
          onClick: () => {
            setApiMsg(false);
          },
        },
      ],
    },
    {
      code: 13, // grupo incompleto
      icon: () => WarningIcon,
      title: "Grupo incompleto",
      description: [
        "Todos los integrantes de tu grupo deben estar en el hall para avanzar con el pago o salir de la tienda.",
      ],
      actions: [
        {
          title: "Entendido",
          colorPrimary: true,
          onClick: () => {
            setApiMsg(false);
          },
        },
      ],
    },
  ];

  useEffect(() => {
    postAccessRequest((state as any).res);

    return () => stopInterval();
  }, []);

  // Pide acceso a puerta si falla debe salir
  const postAccessRequest = async (response: any) => {
    if (response) {
      const accessStoreResponse = JSON.parse(response);
      const codeResponse = parseInt(accessStoreResponse.code);
      // 0 es el primer acceso OK
      if (codeResponse === 0) {
        startInterval();
      } else if (codeResponse === 14) {
        configMsgByCode(codeResponse);
        stopInterval();
      } else {
        const elementCode: any = messagesByCodeDoor.find(
          (el) => el.code === codeResponse
        );
        setIconSelected(elementCode.icon);
        setTitleSelected(elementCode.title);
        setDescSelected(elementCode.description);
        setActionsSelected(elementCode.actions);
        setApiMsg(true);
      }
    }
  };

  if (!apiMsg) return <Loader />;

  return (
    <div>
      <MessageModal
        type="text"
        Icon={iconSelected}
        title={titleSelected}
        text={descSelected}
        actions={actionsSelected}
        handleClose={() => setApiMsg(false)}
        open={apiMsg}
      />
    </div>
  );
};
